// extracted by mini-css-extract-plugin
module.exports = {"page":"ContactPage_page__1n-7P","information":"ContactPage_information__1XJIu","socialLogos":"ContactPage_socialLogos__33iyI","map":"ContactPage_map__1nwt9"};